<template>
  <div>
    <b-card title="Ingresa los datos">

      <!-- form -->
      <validation-observer ref="simpleRules">
        <b-form @submit.prevent="submitForm">
          <b-row>
            <b-col md="6">
              <b-form-group label="Nombre de la Clínica">
                <validation-provider
                  #default="{ errors }"
                  name="Nombre de la Empresa"
                  rules="required"
                >
                  <b-form-input
                    v-model="form.first_name"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Nombre de la Empresa"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Razón Social">
                <validation-provider
                  #default="{ errors }"
                  name="Razón Social"
                  rules="required"
                >
                  <b-form-input
                    v-model="form.last_name"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Razón Social"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Tipo de Documento">
                <validation-provider
                  #default="{ errors }"
                  name="Tipo de Documento"
                  rules="required"
                >
                  <b-form-select
                    v-model="form.document_type"
                    :options="documentTypes"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>

              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Número de Documento">
                <validation-provider
                  #default="{ errors }"
                  name="Número de Documento"
                  rules="required"
                >
                  <b-form-input
                    v-model="form.document_number"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Número de Documento"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Correo Electrónico">
                <validation-provider
                  #default="{ errors }"
                  name="Correo Electrónico"
                  rules="required|email"
                >
                  <b-form-input
                    v-model="form.email"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Correo Electrónico"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Teléfono">
                <validation-provider
                  #default="{ errors }"
                  name="Teléfono"
                  rules="required"
                >
                  <b-form-input
                    v-model="form.phone"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Teléfono"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="WhatsApp">
                <validation-provider
                  #default="{ errors }"
                  name="Número de WhatsApp"
                  rules="required"
                >
                  <b-form-input
                    v-model="form.whatsapp"
                    placeholder="Número de WhatsApp"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>

              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Dirección">
                <b-form-input
                  v-model="form.address"
                  placeholder="Dirección"
                />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="País">
                <b-form-select
                  v-model="selectedCountry"
                  :options="countries"
                  @change="filterDepartments"
                />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="Departamento">
                <b-form-select
                  v-model="selectedDepartment"
                  :options="filteredDepartments"
                  :disabled="!selectedCountry"
                  @change="filterCities"
                />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="Ciudad">
                <b-form-select
                  v-model="selectedCity"
                  :options="filteredCities"
                  :disabled="!selectedDepartment"
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Redes Sociales">

                <b-form-input
                  v-model="form.facebook"
                  class="mb-2"
                  placeholder="Facebook"
                />

                <b-form-input
                  v-model="form.instagram"
                  class="mb-2"
                  placeholder="Instagram"
                />
                <b-form-input
                  v-model="form.youtube"
                  class="mb-2"
                  placeholder="YouTube"
                />
                <b-form-input
                  v-model="form.linkedin"
                  class="mb-2"
                  placeholder="LinkedIn"
                />
              </b-form-group>
            </b-col>

            <!--            <b-col md="6">
              <b-form-group>
                <b-form-checkbox v-model="form.data_policy_accepted">
                  Acepto la política de datos
                </b-form-checkbox>
              </b-form-group>
            </b-col>-->

            <b-col cols="12">
              <b-button
                :disabled="loading"
                :variant="loading ? 'secondary' : 'success'"
                type="submit"
              >
                <b-spinner
                  v-if="loading"
                  small
                  class="mr-2"
                />
                {{ loading ? 'Creando...' : 'Registrar Clínica' }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>

      </validation-observer>

    </b-card>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import {
  BFormInput,
  BRow,
  BCol,
  BFormGroup,
  BCardText,
  BButton,
  BCard,
  BForm,
  BFormSelect,
  BInputGroup,
  BInputGroupPrepend,
  BSpinner,
} from 'bootstrap-vue'
import { required } from '@validations'
import api from '@/plugin/axios'

export default {
  components: {
    BSpinner,
    BInputGroupPrepend,
    BInputGroup,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BCard,
    BForm,
    BFormSelect,
  },
  props: {
    options: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        document_type: '',
        document_number: '',
        whatsapp: '',
        address: '',
        city_id: '',
        department_id: '',
        country_id: '',
        facebook: '',
        instagram: '',
        youtube: '',
        linkedin: '',
        data_policy_accepted: false,
      },
      selectedCountry: null,
      selectedDepartment: null,
      selectedCity: null,
      cities: [],
      departments: [],
      countries: [],
      filteredDepartments: [],
      filteredCities: [],
      documentTypes: [
        { value: 'CC', text: 'Cédula de Ciudadanía' },
        { value: 'CE', text: 'Cédula de Extranjería' },
        { value: 'TI', text: 'Tarjeta de Identidad' },
        { value: 'NIT', text: 'NIT' },
      ],
      roles: [],
      loading: false,
      required,
    }
  },
  async created() {
    const [dataClinicDetails] = await Promise.all([
      api.get('/api/clinic-details/create'),
    ])

    this.cities = dataClinicDetails.data.cities.map(city => ({ value: city.id, text: city.name, department_id: city.department_id }))
    this.departments = dataClinicDetails.data.departments.map(dep => ({ value: dep.id, text: dep.name, country_id: dep.country_id }))
    this.countries = dataClinicDetails.data.countries.map(country => ({ value: country.id, text: country.name }))
  },
  setup() {
  },
  methods: {
    submitForm() {
      this.loading = true
      this.$refs.simpleRules.validate().then(async success => {
        if (success) {
          this.form.country_id = this.selectedCountry
          this.form.department_id = this.selectedDepartment
          this.form.city_id = this.selectedCity
          this.form.role_id = 6 // role_id = 6 Clinica
          try {
            const response = await api.post('/api/clinic-details', this.form)
            this.$bvToast.toast('Clínica registrada con éxito', {
              title: '¡Satisfactoriamente!', // Título del toast
              variant: 'success', // Color del toast
              solid: true, // Hace que el toast no sea translúcido
              autoHideDelay: 5000, // Duración en milisegundos (opcional)
              appendToast: true, // Asegura que se muestre como el más reciente
            })

            this.$router.push({ name: 'admin-clinics' })
          } catch (error) {
            console.log('loading', error)
            if (error.response && error.response.data.errors) {
              const messages = Object.values(error.response.data.errors).flat().join('\n')

              this.$bvToast.toast(messages, {
                title: 'Error',
                variant: 'danger',
                solid: true,
                autoHideDelay: 5000,
              })
            } else {
              this.$bvToast.toast('Ocurrió un error inesperado', {
                title: 'Error',
                variant: 'danger',
                solid: true,
                autoHideDelay: 5000,
              })
            }
          } finally {
            this.loading = false
          }
        }
      })
    },
    filterDepartments() {
      this.selectedDepartment = null
      this.selectedCity = null
      console.log(this.departments)
      this.filteredDepartments = this.departments.filter(dep => parseInt(dep.country_id, 10) === this.selectedCountry)
      this.filteredCities = []
    },
    filterCities() {
      this.selectedCity = null
      this.filteredCities = this.cities.filter(city => parseInt(city.department_id, 10) === this.selectedDepartment)
    },
  },
}
</script>
